module.exports = __webpack_public_path__ + "assets/img/yellow-arrow-left.b268e47c.png";